/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrandingPackageQueryService {

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppBrandingPackageQueryCurrentCompanyBrandingPackageConfig(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/branding-package-query/current-company-branding-package-config',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
